import Vue from 'vue'
import VueJWT from 'vuejs-jwt'

Vue.use(VueJWT)



// WEBPACK FOOTER //
// ./src/bibliotecas/vue/vuejwt.js